import { isObjectNull } from "utils/utils";

const cafeMenuServiceName = "/CafeMenu";

export function menuService (http) {
    return {
        getAllMenusAsync: async (pageNumber, pageSize, sortBy, filters) => {
            debugger;
            const newSort = (sortBy || []).map(item => ({
                member: item.id,
                sortDirection: item.desc ? "Descending" : "Ascending"
            }));
            const filter=filters;
            const data = {
                dataAttribute:{
                    page:pageNumber,
                    pageSize,
                    sorts: newSort.lenght==0?[{member:"Id",sortDirection:"Ascending"}]:newSort,
                    filter: filter
                }
            }
            debugger;
            return await http.post(cafeMenuServiceName + '/GetAllCafeMenus', data);
        },        
        saveNewMenuItemAsync: async (categoruObject, menuItemName, price, validationDate, ingredient, file={}) => {
            let targetFile = !isObjectNull(file) ? {
                address: file.Address,
                fileId: file.fileId,
                fileName: file.fileName,
                fileType: file.fileType,
                result: file.result
            } : null;
            const parameters = {
                categoryId: categoruObject.value,
                itemName: menuItemName,
                unitPrice: price,
                validationDateTime: validationDate,
                ingredients: ingredient,
                file: file,
                category: {
                    id: categoruObject.value,
                    name: categoruObject.label
                },
            };
            return (await http.post(cafeMenuServiceName + '/SaveNewMenuItemAsync', parameters));
        },
        modifyExistingMenuItemAsync: async (menuId, categoruObject, menuItemName, price, validationDate, 
            ingredient, mediaFileId,file={}) => {

            debugger;
            let targetFile = !isObjectNull(file) ? {
                id: menuId,
                address: file.Address,
                fileId: file.fileId,
                fileName: file.fileName,
                fileType: file.fileType,
                result: file.result,
                mediaFileId : mediaFileId

            } : null;
            const parameters = {
                id: menuId, 
                categoryId: categoruObject.value,
                itemName: menuItemName,
                unitPrice: price,
                validationDateTime: validationDate,
                mediaFileId : mediaFileId,
                ingredients: ingredient,
                file: targetFile,
                category: {
                    id: categoruObject.value,
                    name: categoruObject.label
                },
            };
            return (await http.post(cafeMenuServiceName + '/UpdateExistingMenuAsync', parameters));
        },
        deleteExistingMenuAsync: async (categoryId) => {
            const parameters = {
                id: categoryId
            }
            return (await http.post(cafeMenuServiceName + '/DeleteExistingMenuAsync', parameters));
        },
        deleteExistinghMenuImageAsync:  async (menuItemId, mediaFileId) => {
            const parameters = {
                id: menuItemId,
                mediaFileId
            }
            return (await http.post(cafeMenuServiceName + '/DeleteExistinghMenuImageAsync', parameters));
        }
    }
}